import { Component, Input } from '@angular/core';
import { OccConfig } from '@spartacus/core';

@Component({
    selector: 'app-technical-attributes-tab',
    templateUrl: './technical-attributes-tab.component.html',
    styleUrls: ['./technical-attributes-tab.component.scss'],
    standalone: false
})
export class TechnicalAttributesTabComponent {
  @Input() product;
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  constructor(private config: OccConfig) {}
}
